import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";

export default function ProductBreadcrumb({ items = [] }) {
    const navigate = useNavigate();

    return (
        <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm">
        {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
            <div key={`${item.label}-${index}`} className="tw-flex tw-items-center tw-gap-2">
                <button
                type="button"
                onClick={() => item.to && navigate(item.to)}
                disabled={!item.to || isLast}
                className={`tw-rounded-md tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm ${
                    isLast
                    ? "tw-cursor-default tw-font-semibold tw-text-cyan-700"
                    : "tw-text-slate-500 hover:tw-text-slate-900"
                }`}
                >
                {item.label}
                </button>

                {!isLast ? (
                <ChevronRightIcon className="tw-h-4 tw-w-4 tw-text-slate-400" />
                ) : null}
            </div>
            );
        })}
        </div>
    );
}